module.exports = __webpack_public_path__ + "static/media/bn.3e71ac9d.svg";